import withHookForm from '../hoc/withHookForm';
import InputLine from './InputLine';

const InputLineWithHookForm = withHookForm(InputLine);

export default InputLineWithHookForm;
